import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const ProtectedRoute = ({ children, requiredModule }) => {
  const { isAuthenticated, hasModule, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px',
        color: '#667eea'
      }}>
        <div>Cargando...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requiredModule && !hasModule(requiredModule)) {
    return (
      <div style={{ 
        padding: '40px', 
        textAlign: 'center',
        maxWidth: '600px',
        margin: '100px auto',
        backgroundColor: '#fff',
        borderRadius: '10px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
      }}>
        <h2 style={{ color: '#e74c3c', marginBottom: '20px' }}>🚫 Acceso Denegado</h2>
        <p style={{ color: '#666', fontSize: '16px' }}>
          No tienes permisos para acceder a este módulo.
        </p>
        <p style={{ color: '#999', fontSize: '14px', marginTop: '10px' }}>
          Contacta al administrador si necesitas acceso.
        </p>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
